import { useId } from 'react';

import Button from '@helsenorge/designsystem-react/components/Button';
import LazyIllustration from '@helsenorge/designsystem-react/components/LazyIllustration';
import Logo from '@helsenorge/designsystem-react/components/Logo';
import Title from '@helsenorge/designsystem-react/components/Title';

import type { Uthopp } from '@helsenorge/framework-utils/types/Resources';

import DialogModal from './dialog-modal';

import styles from './styles.module.scss';

export interface UthoppDialogProps {
  isOpen: boolean;
  url: string;
  onConfirm: () => void;
  onCancel: () => void;
  resources: Uthopp;
}

const UthoppDialog: React.FC<UthoppDialogProps> = ({ isOpen, url, resources, onConfirm, onCancel }) => {
  const titleId = useId();
  return (
    <DialogModal isOpen={isOpen} onCancel={onCancel} ariaLabelledById={titleId}>
      <Logo className={styles.uthoppdialog__logo} />
      <div className={styles.uthoppdialog__body}>
        <LazyIllustration illustrationName={'MoveAway'} size={200} color="blueberry" />
        <Title id={titleId} appearance="title2">
          {resources.title}
        </Title>
        <p>{resources.description}</p>
        <div className={styles.uthoppdialog__actions}>
          <Button htmlMarkup="a" href={url} onClick={onConfirm}>
            {resources.confirm}
          </Button>
          <Button variant="borderless" onClick={onCancel}>
            {resources.cancel}
          </Button>
        </div>
      </div>
    </DialogModal>
  );
};

export default UthoppDialog;
